import styled from '@emotion/styled';
import { motion } from 'framer-motion';
import { LoaderColor, MAP_LOADER_COLOR_TO_COLOR } from './constants';

export const FullScreenContainer = styled.div(() => {
  return {
    zIndex: 1_000_000,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: '100dvw',
    height: '100dvh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    div: {
      width: '40px',
      height: '40px',
    },
  };
});

interface ILoaderProps {
  color: LoaderColor;
}

export const Loader = styled.div(({ color }: ILoaderProps) => {
  return {
    width: 'var(--size-loader)',
    height: 'var(--size-loader)',
    border: `calc(0.1 * var(--size-loader)) solid ${MAP_LOADER_COLOR_TO_COLOR[color]}`,
    borderBottomColor: 'transparent',
    borderRadius: '50%',
    display: 'inline-block',
    boxSizing: 'border-box',
    '--size-loader': '40px',
  };
});

export const AnimatedLoader = motion(Loader);
